import React from "react";
import { trans } from "../../../localization/language";

class MobileOtpMethodSelectionDialog extends React.Component {
  getClassName = (gateway) => {
    if (gateway.includes("whatsapp")) return "whatsapp";
    if (gateway.includes("viber")) return "viber";
    if (gateway.includes("telegram")) return "telegram";
    if (gateway.includes("line")) return "line";
    if (gateway.includes("sms")) return "sms";
  };

  handleConfirm(option) {
    const { onConfirm } = this.props;
    onConfirm && onConfirm(option);
  };

  handleClose = () => {
    const { onClose } = this.props;
    onClose && onClose();
  };

  render() {
    const { options = [] } = this.props;

    return (
      <div className="verify-mobile-modal selection" onClick={this.handleClose}>
        <div
          className="verify-mobile-modal__dialog"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="verify-mobile-modal__header">
            {trans("register_link_mobile_select_methods")}
          </div>

          <ul className="verify-mobile-modal__list">
            {options.map((option, i) => (
              <li
                key={i}
                className={`verify-mobile-modal__item ${this.getClassName(option)}`}
                onClick={this.handleConfirm.bind(this, option)}
              >
                {trans(option)}
              </li>
            ))}
          </ul>

          <button
            className="verify-mobile-modal__btn secondary"
            onClick={this.handleClose}
          >
            {trans("register_link_mobile_btn_cancel")}
          </button>
        </div>
      </div>
    );
  }
}

export default MobileOtpMethodSelectionDialog;



// WEBPACK FOOTER //
// ./app/components/security/verification/MobileOtpMethodSelectionDialog.js